<template>
  <v-card elevation="0" class="pa-6">
    <div class="d-flex align-center mb-4">
      <h3 class="mb-0">{{ $t('finance.loanApplications.landSuitabilitySectionTitle') }}</h3>
    </div>

    <v-row>
      <v-col cols="12" md="4">
        <v-card elevation="1" class="pa-5 score-card">
          <div class="score-label mb-2">{{ $t('finance.loanApplications.overallSuitabilityScoreLabel') }}</div>
          <div class="score-value">79.57%</div>
          <div class="score-category mt-2">{{ $t('finance.loanApplications.moderate') }}</div>
        </v-card>
      </v-col>

      <v-col cols="12" md="8">
        <v-card elevation="1" class="pa-5">
          <div class="font-weight-medium mb-2">{{ $t('finance.loanApplications.suitabilityFactorsPlaceholder') }}</div>
          <v-row>
            <v-col cols="12" md="6" class="mb-3">
              <div class="factor-title">{{ $t('finance.loanApplications.factorSoilQuality') }}</div>
              <v-progress-linear value="78" height="10" color="#00BD73" />
            </v-col>
            <v-col cols="12" md="6" class="mb-3">
              <div class="factor-title">{{ $t('finance.loanApplications.factorClimateFit') }}</div>
              <v-progress-linear value="81" height="10" color="#4aa3ff" />
            </v-col>
            <v-col cols="12" md="6" class="mb-3">
              <div class="factor-title">{{ $t('finance.loanApplications.factorWaterAvailability') }}</div>
              <v-progress-linear value="76" height="10" color="#00BD73" />
            </v-col>
            <v-col cols="12" md="6" class="mb-3">
              <div class="factor-title">{{ $t('finance.loanApplications.factorRiskFactors') }}</div>
              <v-progress-linear value="63" height="10" color="#F03737" />
            </v-col>
          </v-row>
          <div class="text-body-2 mt-2">
            {{ $t('finance.loanApplications.landSuitabilityExpertFooter') }}
          </div>
        </v-card>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
export default {
  name: 'LandSuitabilityReportDetails',
  props: {
    application: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>

<style scoped>
.score-card {
  border-left: 4px solid #00BD73;
}

.score-label {
  color: #555;
}

.score-value {
  font-size: 24px;
  font-weight: 800;
  color: #333;
}

.score-category {
  font-weight: 700;
  color: #666;
}

.factor-title {
  font-size: 13px;
  color: #555;
  margin-bottom: 6px;
}
</style>

